// Helpers for importing route files (GPX etc.) via drag-and-drop.
// Extensions mirror the accept list used by the manual "Import Hike" file picker
// in TrailImportDialog, so both entry points support the same formats.
export const SUPPORTED_IMPORT_EXTENSIONS = ['gpx', 'kml', 'kmz', 'tcx', 'geojson', 'json'];

export function isFileDrag(dataTransfer: Pick<DataTransfer, 'types'> | null): boolean {
  if (!dataTransfer) {
    return false;
  }
  return Array.from(dataTransfer.types || []).includes('Files');
}

export function getSupportedImportFile(files: ArrayLike<Pick<File, 'name'>> | null | undefined): File | null {
  const list = Array.from(files || []);
  const match = list.find((file) => {
    const name = file.name || '';
    const dotIndex = name.lastIndexOf('.');
    if (dotIndex <= 0) {
      return false;
    }
    const extension = name.slice(dotIndex + 1).toLowerCase();
    return SUPPORTED_IMPORT_EXTENSIONS.includes(extension);
  });
  return (match as File) || null;
}
